import React, { ReactNode } from 'react'

function MainLayout({ children }: { children: ReactNode }) {
  return <div className='flex flex-col w-full h-full overflow-y-auto'>{children}</div>
}

export default MainLayout
